interface Logo {
  href: string
  src: string
  alt: string
}

interface NavLink {
  href: string
  label: string
}

import { SIGNUP_PRODUCT } from './config'

interface NavConfig {
  logo: Logo
  navLinks: NavLink[]
  registerLink: {
    href: string
    label: string
  }
}

const navConfig: NavConfig = {
  logo: {
    href: '/magic-conventions/the-session/',
    src: 'https://vinc.gumlet.io/pics/conventions/the-session/logo-white.png?w=1300&dpr=1',
    alt: 'The Session Logo',
  },
  navLinks: [
    { href: '/magic-conventions/the-session/schedule/', label: 'Schedule' },
    {
      href: '/magic-conventions/the-session/inevitable/',
      label: 'Inevitable',
    },
    {
      href: '/magic-conventions/the-session/youth-scholarship/',
      label: 'Scholarships',
    },
    { href: '/magic-conventions/the-session/#streaming', label: 'Streaming' },
    { href: '/magic-conventions/the-session/#hotel', label: 'Hotel' },
  ],
  registerLink: {
    href: `/magic-conventions/${SIGNUP_PRODUCT}/register/`,
    label: 'Register Now',
  },
}

export default navConfig
